import { render, staticRenderFns } from "./OtherLoans.vue?vue&type=template&id=60e11ec1"
import script from "./OtherLoans.vue?vue&type=script&lang=js"
export * from "./OtherLoans.vue?vue&type=script&lang=js"
import style0 from "./OtherLoans.vue?vue&type=style&index=0&id=60e11ec1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports